var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6dcef8;}.b{fill:#2450ff;}.c{fill:#069de5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-540 -1510)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 2,
    rx: 1,
    transform: "translate(540 1568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,0H36a6,6,0,0,1,6,6v6a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V6A6,6,0,0,1,6,0Z",
    transform: "translate(549 1556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.89,46h22.287a1.861,1.861,0,0,0,1.694-1.131,1.97,1.97,0,0,0-.3-2.059c-.069-.081-6.961-8.2-6.961-15.977a32.12,32.12,0,0,1,2.3-11.35,18.31,18.31,0,0,0,1.418-5.9,9.291,9.291,0,1,0-18.572,0,18.31,18.31,0,0,0,1.418,5.9,32.12,32.12,0,0,1,2.3,11.35c0,7.777-6.892,15.9-6.961,15.977a1.97,1.97,0,0,0-.3,2.059A1.861,1.861,0,0,0,99.89,46Z",
    transform: "translate(458.967 1510)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6,0H44a6,6,0,0,1,6,6v6a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V6A6,6,0,0,1,6,0Z",
    transform: "translate(545 1550)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-5727-129a2,2,0,0,1-2-2h42a2,2,0,0,1-2,2Z",
    transform: "translate(6278 1699)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.ba11e171d45d0e29e8da2970de47dfaf.svg";
export { ForwardRef as ReactComponent };